import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import {
  type CommitteeBasicInformation,
  type LegStaffInformation,
  transformAddress, transformRequestStaffer,
  transformResponseAddress
} from 'services'
import { type BulkAssignResult } from '../member/memberStaffService'
import { getEmptyPersonAddress, getEmptyStafferEmail } from 'helpers'

export interface CommitteeStaffInformation extends LegStaffInformation {
  committee: CommitteeBasicInformation
  majMin: string
}

export async function retireStafferFromCommittee (comId: number, stafferId: number): Promise<HttpResponse<void>> {
  return await handleHttpRequest(http.post(`/api/v1/us/committee/${comId}/staff/${stafferId}/`))
}

export async function bulkAssignCommittee (legComId: number, displayOrder: number): Promise<HttpResponse<BulkAssignResult>> {
  const response = await http.post<HttpResponse<BulkAssignResult>>(
    `/api/v1/us/committee/${legComId}/addresses/${displayOrder}/bulk-assign/`
  )
  return response.data
}

export async function updateComStafferDisplayOrder (comId: number, IdsAnddisplayOrders: Record<number, number>, selectedId: number, roleType: number, majMin: string): Promise<HttpResponse<[]>> {
  const payload = {
    idAndDisplayOrderMap: IdsAnddisplayOrders,
    selectedId,
    roleType,
    majMin
  }
  return await http.patch(`/api/v1/us/committee/${comId}/staff/`, payload).then(response => response.data)
}

export async function getStaffByCommittee (comId: number): Promise<CommitteeStaffInformation[]> {
  return await http.get(`/api/v1/us/committee/${comId}/staff/`).then(response => {
    return response.data.map((data: any) => {
      return {
        ...data,
        email: data.email != null
          ? {
              id: data.email.id,
              value: data.email.value,
              personId: data.person.id,
              lastUpdated: data.email.lastUpdated,
              typeId: 1,
              descId: data.legmemOfficeLocationId === 1 ? 8 : 13,
              displayOrder: data.email.displayOrder
            }
          : getEmptyStafferEmail(data.person.id),
        address: data.address != null
          ? {
              id: data.address.id,
              typeId: data.address.typeId,
              primary: transformAddress(data.address, 'primary'),
              secondary: transformAddress(data.address, 'secondary'),
              mailingAddress: data.address.mailingAddress,
              phones: data.address.phones,
              displayOrder: data.address.displayOrder,
              updatedBy: data.address.updatedBy,
              lastUpdated: data.address.lastUpdated
            }
          : getEmptyPersonAddress(data.person.id)
      }
    })
  })
}

export async function updateComStaffer (staffer: CommitteeStaffInformation): Promise<HttpResponse<CommitteeStaffInformation>> {
  const response = await http.put(
    `/api/v1/us/committee/${staffer.committee.id}/staff/${staffer.id}/`,
    transformRequestStaffer(staffer)
  )

  return {
    ...response.data,
    result: {
      ...response.data.result,
      address: transformResponseAddress(response.data.result.address)
    }
  }
}

export async function createComStaffer (staffer: CommitteeStaffInformation): Promise<HttpResponse<CommitteeStaffInformation>> {
  const response = await http.post(
    `/api/v1/us/committee/${staffer.committee.id}/staff/`,
    transformRequestStaffer(staffer)
  )

  return {
    ...response.data,
    result: {
      ...response.data.result,
      address: transformResponseAddress(response.data.result.address)
    }
  }
}
